import { KeyboardBackspace as KeyboardBackspaceIcon } from '@mui/icons-material';
import { Box } from '@mui/material';

import { StyledIconButton } from './IssueForm.styled.js';

export const IssueFormNext = (props: { onClick: () => void }) => {
  return (
    <Box display="flex" justifyContent="flex-end" mt={2}>
      <StyledIconButton onClick={props.onClick} disableRipple>
        <KeyboardBackspaceIcon color="primary" />
      </StyledIconButton>
    </Box>
  );
};
